export const TRY_IT_FOR_FREE_CTA = 'Try it for free'
